import { render, staticRenderFns } from "./SysPositionModal.vue?vue&type=template&id=6dbfc6c7&scoped=true&"
import script from "./SysPositionModal.vue?vue&type=script&lang=js&"
export * from "./SysPositionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbfc6c7",
  null
  
)

export default component.exports